<ms-teaser *ngIf="!hidden" [teasers]="teasers" [promotions]="promotions"></ms-teaser>
